import { STATIC_OPTION } from '@/pages/intelligence/pages/TopCharts/_config/echarts';

import type { IEChartOption } from '@/pages/intelligence/types/echart';

export function getEChartStaticOption(formatters?: {
  xAxisLabelFormatter?: (payload: any) => any;
  yAxisLabelFormatter?: (payload: any) => any;
  serieNameFormatter?: (payload: any) => any;
}): IEChartOption {
  const xAxisLabelFormatter = formatters?.xAxisLabelFormatter;
  const yAxisLabelFormatter = formatters?.yAxisLabelFormatter;
  const serieNameFormatter = formatters?.serieNameFormatter;

  return {
    ...STATIC_OPTION,
    grid: {
      ...STATIC_OPTION.grid,
    },
    xAxis: {
      ...STATIC_OPTION?.xAxis,
      axisLabel: {
        // @ts-ignore
        ...STATIC_OPTION?.xAxis?.axisLabel,
        formatter: xAxisLabelFormatter,
      },
    },
    yAxis: {
      ...STATIC_OPTION?.yAxis,
      axisLabel: {
        // @ts-ignore
        ...STATIC_OPTION?.yAxis?.axisLabel,
        formatter: yAxisLabelFormatter,
      },
    },
    legend: {
      ...STATIC_OPTION?.legend,
      formatter: serieNameFormatter,
    },
  };
}

/** 构建带维度图标（ECharts Rich Text）的图例配置 */
export function buildDimensionIconLegendOption(options: {
  sourceDataDimensions?: string[];
  dimensionIconFormatter?: (name: string) => string;
  sourceDataDimensionNameFormatter?: (name: string) => string;
}) {
  const { sourceDataDimensions, dimensionIconFormatter, sourceDataDimensionNameFormatter } = options;

  // 无图标 formatter 时回退为纯文本
  if (!dimensionIconFormatter || !sourceDataDimensions?.length) {
    return { formatter: sourceDataDimensionNameFormatter };
  }

  // 生成 ECharts rich text 图标配置
  const iconRichMap: Record<
    string,
    { backgroundColor: { image: string }; height: number; width: number; verticalAlign?: string }
  > = {};
  const dimensionIconKeys: Record<string, string> = {};

  sourceDataDimensions.forEach((dim: string, index: number) => {
    const icon = dimensionIconFormatter(dim);
    if (icon) {
      const key = `dim_icon_${index}`;
      dimensionIconKeys[dim] = key;
      iconRichMap[key] = {
        backgroundColor: { image: icon },
        height: 16,
        width: 16,
        verticalAlign: 'middle',
      };
    }
  });

  if (Object.keys(iconRichMap).length === 0) {
    return { formatter: sourceDataDimensionNameFormatter };
  }

  return {
    formatter: (name: string) => {
      const displayName = sourceDataDimensionNameFormatter?.(name) || name;
      const iconKey = dimensionIconKeys[name];
      if (iconKey) {
        return `{${iconKey}|} {text|${displayName}}`;
      }
      return displayName;
    },
    textStyle: {
      rich: {
        ...iconRichMap,
        text: {
          color: '#888888',
          fontSize: 12,
        },
      },
    },
  };
}
